import React, { createContext, useContext, useState, useCallback } from "react";
import { useApiFresh } from "@/lib/swr";

const WeekSettingsContext = createContext(null);

const DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function WeekSettingsProvider({ children }) {
  const [weekStartDay, setWeekStartDay] = useState(5); // Friday
  const [excludeUndelivered, setExcludeUndelivered] = useState(true);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsVersion, setVersion] = useState(0); // bumps on apply to trigger refetches
  const version = settingsVersion + useApiFresh(); // also bumps when background refreshes bring new data

  const applySettings = useCallback((newDay, newExclude) => {
    setWeekStartDay(newDay);
    setExcludeUndelivered(newExclude);
    setVersion(v => v + 1);
    setSettingsOpen(false);
  }, []);

  return (
    <WeekSettingsContext.Provider value={{
      weekStartDay, excludeUndelivered,
      settingsOpen, setSettingsOpen,
      applySettings, version,
      DAY_NAMES,
    }}>
      {children}
    </WeekSettingsContext.Provider>
  );
}

export function useWeekSettings() {
  const ctx = useContext(WeekSettingsContext);
  if (!ctx) throw new Error("useWeekSettings must be used within WeekSettingsProvider");
  return ctx;
}
